<div class="events-container">
  <ag-grid-angular
    class="ag-theme-balham-dark events-container__ag-grid"
    [enableRangeSelection]="true"
    [columnDefs]="headers"
    [defaultColDef]="defaultColDef"
    [autoGroupColumnDef]="{ sortable: true }"
    rowSelection="multiple"
    [groupSelectsChildren]="true"
    [suppressRowClickSelection]="true"
    [sideBar]="sideBarDef"
    (gridReady)="onGridReady($event)"
    (sortChanged)="gridStateChanged($event)"
    (columnResized)="gridStateChanged($event)"
    (columnVisible)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPivotChanged)="gridStateChanged($event)"
    (columnRowGroupChanged)="gridStateChanged($event)"
    (columnValueChanged)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPinned)="gridStateChanged($event)"
    [rowData]="rowData"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  >
  </ag-grid-angular>

  <div class="events-container__footer">
    <div class="events-container__footer__info">
      <ng-container *ngIf="state.info">{{ state.info }}</ng-container>
      <ng-container
        *ngIf="state.runningState === RunningState.Running && !state.info"
      >
        Report running. Some reports might take a while.
      </ng-container>
    </div>

    <form [formGroup]="form">
      <input
        type="text"
        placeholder="Date (YYYY-MM-DD)"
        clrInput
        type="text"
        formControlName="date"
        spellcheck="false"
        autocomplete="off"
        pattern="\d\d\d\d-\d\d-\d\d"
      />
      <input
        type="text"
        placeholder="Time (HH:MM)"
        clrInput
        type="text"
        formControlName="time"
        spellcheck="false"
        autocomplete="off"
        pattern="\d\d:\d\d"
      />
      <app-selector
        [isSearch]="true"
        [passedItems]="timezones"
        placeholder="Timezone"
        formControlName="timezone"
      ></app-selector>
      <app-selector
        [isSearch]="true"
        [passedItems]="entities"
        placeholder="Select an entity or type to search"
        formControlName="entity"
      ></app-selector>
    </form>
    <div class="events-container__footer__buttons">
      <button
        type="button"
        class="ui-button ui-button__header ui-button--danger"
        [disabled]="state.runningState === RunningState.Idle"
        (click)="cancelReport()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ui-button ui-button__header ui-button--primary"
        [disabled]="
          state.runningState === RunningState.Running || !canRunReport()
        "
        (click)="runReport()"
      >
        Run
      </button>
    </div>
  </div>
</div>
